import { endPoints, API_ROOT } from "./../../../appSettings";
import { adalApiFetch } from "../../../authProvider";
export const GET_LIST = "GET_LIST";
export const GET_CHECKSUM = "GET_CHECKSUM";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPDATE_FILE = "UPDATE_FILE";
export const DELETE_FILE = "DELETE_FILE";
export const GET_FILE_TYPES = "GET_FILE_TYPES";

export const GetList = (props) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/list?page=${props.pagination.currentPage}&limit=${props.pagination.pageSize}&orderBy=${props.orderBy}&searchText=${props.search}&searchBy=${props.searchBy}&operation=${props.operation}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_LIST,
          payload: json,
        });
      });
};

export const GetChecksum = (file) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/checksum`,
      {
        method: "POST",
        body: file,
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_CHECKSUM,
          isSuccess: true,
          payload: json,
        });
      });
};

export const UploadFile = (file) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/upload`,
      {
        method: "POST",
        body: file,
      },
      dispatch
    ).then((response) => {
      if (!response.ok) {
        return Promise.reject(response.json());
      }
      return response.json().then((json) => {
        return dispatch({
          type: UPLOAD_FILE,
          isSuccess: true,
          payload: json,
        });
      });
    });
};

export const UpdateFile = (file) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}`,
      {
        method: "PUT",
        body: file,
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_FILE,
              isSuccess: false,
              payload: json,
            });
          });
        }
        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_FILE,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const DeleteFile = (id) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/${id}`,
      {
        method: "DELETE",
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_FILE,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_FILE,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const GetFileTypes = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/file-types`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_FILE_TYPES,
          isSuccess: true,
          payload: json,
        });
      });
};

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};

export const DownloadReleaseNotes = (filename) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/releasenotes/${filename}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        if (response.ok) {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
};

export const GetLanguageCodes = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.languageCodes}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => response.json())
      .catch((error) => {
        console.log(error);
      });
};
